package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.attestation.AttestationDTO
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.store.PortalInputLabelStyle
import gr.tech.GRAttestation.styles.store.PortalTextStyle
import gr.tech.GRAttestation.util.ROUTES
import gr.tech.GRAttestation.util.TimeUtils
import gr.tech.GRAttestation.util.formatCurrency
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.*

@Composable
fun StoreAttestationHistoryTable(attestations: List<AttestationDTO>) {
    Table(
        attrs = Modifier.fillMaxWidth().classNames("table", "table-hover", "table-sm").toAttrs()
    ) {
        Thead {
            Tr {
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Month") }
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Rep.") }
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Products") }
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Units") }
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Incentive") }
                Th(attrs = PortalInputLabelStyle.toModifier().toAttrs()) { Text("Submitted") }
                Th(attrs = Modifier.width(1.cssRem).toAttrs()) { }
            }
        }
        Tbody(Modifier.fontSize(0.875.cssRem).toAttrs()) {
            attestations.forEach { record ->
                val totalUnits = record.salesData.sumOf { it.quantity }
                val totalRebate = record.salesData.sumOf { it.skuModel.unitPrice * it.quantity }
                Tr(
                    attrs = Modifier
                        .cursor(Cursor.Pointer)
                        .toAttrs {
                            onClick {
                                window.open("${ROUTES.BACKEND.FORMS.FORMS_DOWNLOAD}/${record.id}", "_blank")
                            }
                        }
                ) {
                    Td(attrs = PortalTextStyle.toModifier().fontSize(0.875.cssRem).toAttrs()) { Text(record.reportingMonth) }
                    Td(attrs = Modifier.toAttrs()) { Text(record.repName) }
                    Td(attrs = Modifier.fontWeight(FontWeight.Light).toAttrs()) { Text(record.salesData.joinToString(", ") { it.skuModel.description }) }
                    Td(attrs = Modifier.fontWeight(FontWeight.Light).toAttrs()) { Text(totalUnits.toString()) }
                    Td(attrs = PortalTextStyle.toModifier().fontSize(0.875.cssRem).toAttrs()) { Text(formatCurrency(totalRebate)) }
                    Td(attrs = Modifier.fontWeight(FontWeight.Light).toAttrs()) { Text(TimeUtils.formatDateTime(record.createdAt)) }
                    Td(attrs = Modifier.toAttrs()) {
                        FaDownload(
                            modifier = Modifier.color(Theme.DarkGreen.rgb),
                            size = IconSize.SM
                        )
                    }
                }
            }
        }
    }
}
